// extracted by mini-css-extract-plugin
export default {"inhecoScilaCloseDrawerDialog":"inhecoScilaCloseDrawerDialog-sdiFM","text":"text-sBGgP","closeDrawerMessage":"closeDrawerMessage-AL181"};